import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const imgURLToBase64 = async (url: string) => {
  // 下载图片
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  const buffer = Buffer.from(arrayBuffer);

  // 转换为 base64
  const base64Image = buffer.toString("base64");

  // 获取 MIME 类型
  const contentType = response.headers.get("content-type");

  // 创建完整的 base64 字符串
  const base64String = `data:${contentType};base64,${base64Image}`;
  return base64String;
};
